<template>
  <v-container class="app" grid-list-md text-xs-center fluid>
    
    <!-- component content -->
    <div class="grid">
      <div id="header" ref="header">
        <v-card class="input-card">

          <div class="input-card-content">
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.startTime" 
                  label="Start Time" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm3>
                <v-select
                  solo
                  v-model="filterVals.startTimeComparator"
                  :items="comparatorOptions.beforeAfter"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.startTime"
                  required
                >
                </v-select>
              </v-flex>
              <v-flex sm5>
                <v-text-field
                  solo
                  label="Datetime"
                  v-model="filterVals.startTime"
                  :disabled="!activeFields.startTime"
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.endTime" 
                  label="End Time" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm3>
                <v-select
                  solo
                  v-model="filterVals.endTimeComparator"
                  :items="comparatorOptions.beforeAfter"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.endTime"
                  required
                >
                </v-select>
              </v-flex>
              <v-flex sm5>
                <v-text-field
                  solo
                  label="Datetime"
                  v-model="filterVals.endTime"
                  :disabled="!activeFields.endTime"
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.userEmail" 
                  label="User's Email" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-text-field
                  solo
                  label="Email"
                  v-model="filterVals.userEmail"
                  :disabled="!activeFields.userEmail"
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.userName" 
                  label="User's Name" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-text-field
                  solo
                  label="Name"
                  v-model="filterVals.userName"
                  :disabled="!activeFields.userName"
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.userBrowser" 
                  label="User's Browser" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-select
                  solo
                  v-model="filterVals.userBrowser"
                  :items="browserOptions"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.userBrowser"
                  required
                >
                </v-select>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.userOs" 
                  label="User's Operating System" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-select
                  solo
                  v-model="filterVals.userOs"
                  :items="osOptions"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.userOs"
                  required
                >
                </v-select>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.appUsed" 
                  label="Application Used" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-select
                  solo
                  v-model="filterVals.appUsed"
                  :items="appOptions"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.appUsed"
                  required
                >
                </v-select>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.customerName" 
                  label="Customer's Name" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-text-field
                  solo
                  label="Name"
                  v-model="filterVals.customerName"
                  :disabled="!activeFields.customerName"
                  required
                >
                </v-text-field>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.score" 
                  label="Score Given" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm3>
                <v-select
                  solo
                  v-model="filterVals.scoreComparator"
                  :items="comparatorOptions.lessGreaterEqual"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.score"
                  required
                >
                </v-select>
              </v-flex>
              <v-flex sm5>
                <v-select
                  solo
                  v-model="filterVals.score"
                  :items="scoreOptions"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.score"
                  required
                >
                </v-select>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm4>
                <v-checkbox
                  v-model="activeFields.usePurpose" 
                  label="Usage Purpose Given" 
                >
                </v-checkbox>
              </v-flex>
              <v-flex sm8>
                <v-select
                  solo
                  v-model="filterVals.usePurpose"
                  :items="usePurposeOptions"
                  item-text="name"
                  item-value="value"
                  :disabled="!activeFields.usePurpose"
                  required
                >
                </v-select>
              </v-flex>
            </v-layout>
            
            <v-layout row>
              <v-flex sm12>
                <v-checkbox
                  v-model="activeFields.hasComments" 
                  label="Has Comments" 
                >
                </v-checkbox>
              </v-flex>
            </v-layout>
            
            <v-btn 
              color="success"
              @click="exportData()"
            >
              Export Usage Data
            </v-btn>
          </div>
        </v-card>
      </div>
    </div>
  </v-container>
</template>


<script>
import _ from 'lodash'
import logoImage from '@/assets/jll-logo.png'

export default {
  data () {
    return {
      activeFields: {
        startTime: false,
        endTime: false,
        userEmail: false,
        userName: false,
        userBrowser: false,
        userOs: false,
        appUsed: false,
        customerName: false,
        score: false,
        hasComments: false,
        usePurpose: false
      },
      filterVals: {
        startTimeComparator: 'After',
        startTime: '',
        endTimeComparator: 'Before',
        endTime: '',
        userEmail: '',
        userName: '',
        userBrowser: '',
        userOs: '',
        appUsed: '',
        customerName: '',
        scoreComparator: 'LessThan',
        score: 0,
        usePurpose: '',
      },
      comparatorOptions: {
        beforeAfter: [
          { name: "Before", value: "Before" },
          { name: "After", value: "After" }
        ],
        lessGreaterEqual: [
          { name: "Less than", value: "LessThan" },
          { name: "Greater than", value: "GreaterThan" },
          { name: "Equal to", value: "Equals" }
        ]
      },
      browserOptions: [
        { name: "Firefox", value: "Firefox" },
        { name: "Opera", value: "Opera" },
        { name: "IE", value: "IE" },
        { name: "Edge", value: "Edge" },
        { name: "Chrome/Chromium", value: "Chrome/Chromium" },
        { name: "Safari", value: "Safari" },
        { name: "unknown", value: "unknown" }
      ],
      osOptions: [
        { name: "Windows", value: "Windows" },
        { name: "MacOS", value: "MacOS" },
        { name: "UNIX", value: "UNIX" },
        { name: "Linux", value: "Linux" },
        { name: "iOS", value: "iOS" },
        { name: "Android", value: "Android" },
        { name: "unknown", value: "unknown" },
      ],
      appOptions: [
        { name: "Network Analyzer", value: "NA" },
        { name: "Facility Cost Calculator", value: "FC" },
      ],
      scoreOptions:[
        { name: "1", value: 1 },
        { name: "2", value: 2 },
        { name: "3", value: 3 },
        { name: "4", value: 4 },
        { name: "5", value: 5 },
      ],
      usePurposeOptions: [
        { name: "Practicing", value: "_practicing" },
        { name: "Sharing with a client", value: "_sharing_client" },
        { name: "Consulting with my client", value: "_consulting" },
        { name: "Sharing with my colleague", value: "_sharing_colleague" },
        { name: "Other", value: "_other" }
      ]
    }
  },

  mounted: function () {
  },

  components: {
  },

  computed: {
  },

  methods: {
    exportData() {
      let filterParam = {}
      Object.keys(this.activeFields).forEach((fieldKey) => {
        if(this.activeFields[fieldKey]){
          if(fieldKey == "hasComments"){
            return filterParam.hasComments = true
          }
          
          let paramKey = fieldKey
          // if the field has a comparator, append the comparator value to the key
          if(this.filterVals[fieldKey + "Comparator"]){
            paramKey = fieldKey + this.filterVals[fieldKey + "Comparator"]
          }
          filterParam[paramKey] = this.filterVals[fieldKey]
        }
      })
      
      if(!filterParam || !Object.keys(filterParam).length){
        filterParam.startTimeBefore = new Date().toISOString().slice(0, 19).replace('T', ' ')
      }
      
      this.$store.dispatch('findSessions', filterParam).then((sessions) => {
        let csvContent = "session_id,user_sub,user_email,user_name,user_ip,user_browser,user_os,app_used,customer_name,score,use_purpose,comments,start_time,end_time\r\n"
        sessions.forEach((session) => {
          let usePurposeFriendlyString = session.use_purpose || ""
          this.usePurposeOptions.find((usePurposeOption) => {
            if(usePurposeOption.value == usePurposeFriendlyString){
              usePurposeFriendlyString = usePurposeOption.name
            }
          })
          
          let sessionLine = [
            session.session_id || "", 
            session.user_sub || "", 
            session.user_email || "", 
            session.user_name || "", 
            session.user_ip || "", 
            session.user_browser || "", 
            session.user_os || "",
            session.app_used || "",
            session.customer_name || "",
            session.score || "", 
            usePurposeFriendlyString,
            session.comments || "",
            session.start_time ? new Date(session.start_time).toLocaleString().replace(",", "") : "",
            session.end_time ? new Date(session.end_time).toLocaleString().replace(",", "") : ""
          ].join(",") + "\r\n";
          
          csvContent += sessionLine;
        });
        
        let filename = "JLL Calculator Usage Data (" + new Date().toLocaleDateString() + ")";
        
        // https://stackoverflow.com/questions/23301467
        let csvData = new Blob([csvContent], { type: 'text/csv' });
        let csvUrl = URL.createObjectURL(csvData);
        let link = document.createElement("a");
        link.setAttribute("href", csvUrl);
        link.setAttribute("download", filename + ".csv");
        document.body.appendChild(link); 
        
        link.click();
      })
    },
  }
}

</script>


<style scoped>
.app {
  height: 100%;
  overflow: scroll;
}

.grid {
  display: grid;
  text-align: left;
  font-size: 13pt;
  min-height: 100%;
  max-height: 100%;
  width: 100%;
  grid-gap: 0.5em;
  grid-template-columns: 1fr 1fr;
  grid-template-rows: 165px auto auto;
}
.adjust-actions {
  display: inline-block;
  font-size: 10pt;
  position: absolute;
  right: 180px;
  top: 5px;
}
#header {
  grid-column: 1 / -1;
}

.section-title {
  text-align: left;
  padding-left: 10px;
  color: #444;
}
.navigator-link {
  position: absolute;
  right: 13px;
  top: 3px;
  font-size: 10pt;
}
h1, h2 {
  font-weight: normal;
  color: #707070;
}
hr {
  height: 1px;
  border: 0;
  border-top: 1px solid #ccc;
}
ul {
  list-style-type: none;
  padding: 0;
}
li {
  display: inline-block;
  margin: 0 10px;
}
a:link, a:visited, a:active {
  text-decoration: none;
}
a:hover {
  font-weight: bold;
}

.input-card {
}
.input-card-content {
  padding: 20px;
}

@media only screen and (max-width: 600px) {

}

@media only screen and (max-height: 550px) {

}

</style>
